import React, { useEffect, useState, useRef } from "react";

//import para inicio de sesion y consultas
import { onAuthStateChanged } from 'firebase/auth';
import { auth, getUserInfo } from '../../firebase/firebase';

//import para ver permisos
import { hasPermission } from '../../firebase/permisos';

//import para navigate
import { useNavigate } from 'react-router-dom';

//importacion del MENU
import Menu from '../menu';
import HeaderHome from '../header';

//para generar PDF
import PDFComponent, { getPDFStyles } from './pdfCreate';

//modal de carga
import LoadingModal from '../Loading-Modal/loading.jsx'

//import para funciones especificas de esta pantalla
import { useLocation } from 'react-router-dom';
import { Timestamp } from 'firebase/firestore';
import { getNextVoucherNumber, getAccountsDetail, addVoucher } from '../../firebase/vouchers'
import { getProviders, addNewProvider, getProjects } from '../../firebase/requisiciones'
import { FiPrinter } from 'react-icons/fi';
import { IoIosArrowDown, IoIosArrowUp, IoIosArrowBack } from 'react-icons/io';

import './nuevo_voucher.css'


function NuevoVoucher(props) {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false); // Estado para controlar el modal de carga

    // constante para recibir el state desde la pantalla que solicito 
    const location = useLocation();

    const [requiSel, setRequiSel] = useState(location.state ? location.state.requiSel : null);

    // Efecto para actualizar/clear el estado cuando cambia la ubicación
    useEffect(() => {
        // Esta lógica se ejecutará cada vez que 'location' cambie
        setRequiSel(location.state ? location.state.requiSel : null);
    }, [location]); // Dependencia en 'location'



    const [useUser, setUseUser] = useState({
        nombre: '',
        rol: '',
        email: '',
        genero: '',
        fechaIni: '',
        cumple: '',
        tel: '',
        foto: ''
    });

    const [loading, setLoading] = useState(true);
    const hasCheckedPermission = useState(false);

    //estados para cargar informacion
    const [accounts, setAccounts] = useState();
    const [proveedores, setProveedores] = useState([]);
    const [proyectos, setProyectos] = useState([]);
    const [correlativo, setCorrelativo] = useState(0);

    //cambio de color en bordes
    const [buttonClicked, setButtonClicked] = useState(false);
    const [buttonClickedB, setButtonClickedB] = useState(false);
    const [numCheckTouched, setNumCheckTouched] = useState(false);
    const [dateCheckTouched, setDateCheckTouched] = useState(false);
    const [descripcionTouched, setDescripcionTouched] = useState(false);
    const [montoTouched, setMontoTouched] = useState(false);

    // Este useEffect maneja el estado del usuario
    useEffect(() => {
        if (!hasCheckedPermission.current) {
            onAuthStateChanged(auth, handleUserStateChanged);
            hasCheckedPermission.current = true;
        }
    }, []);

    async function handleUserStateChanged(user) {
        if (user) {
            try {
                const res = await getUserInfo(user.uid);
                if (res != null) {
                    setUseUser(prevState => ({
                        ...prevState,
                        nombre: res.nombre,
                        rol: res.rol,
                        email: res.email,
                        genero: res.genero,
                        fechaIni: res.fechaIni.toDate().toLocaleDateString(),
                        cumple: res.cumple.toDate().toLocaleDateString(),
                        tel: res.tel,
                        foto: res.foto
                    }));

                    //Cargar datos para usar en la pantalla al cargar
                    setAccounts(await getAccountsDetail());
                    setProveedores(await getProviders());
                    setProyectos(await getProjects());
                    setCorrelativo(await getNextVoucherNumber());
                    setLoading(false); // para saber si termino de cargar los datos del usuario

                    const canAccess = await hasPermission(res.rol, "voucher/nuevo");
                    if (!canAccess) {
                        props.showErr('Usted no tiene permisos para acceder a esta función.')
                        navigate('/home');
                        return;
                    }

                } else {
                    setUseUser(prevState => ({
                        ...prevState,
                        nombre: 'N/A',
                        rol: 'N/A',
                        email: 'N/A',
                        genero: 'N/A',
                        fechaIni: 'N/A',
                        cumple: 'N/A',
                        tel: 'N/A',
                        foto: 'N/A'
                    }));
                }
            } catch {
                console.log('NO HAY USUARIO :(');
                navigate('/login');
            }
        } else {
            navigate('/login');
        }
    }

    //Menú desplegable 
    const [isOpen, setIsOpen] = useState(false);
    const [isAccountOpen, setAccountOpen] = useState(false);
    const [isProjectOpen, setProjectOpen] = useState(false);


    const [update, setUpdate] = useState(false);

    //Campos State para uso de funcionalidades
    const [selectedAccount, setSelectedAccount] = useState(''); // Guarda el ID de la cuenta seleccionada.
    const [selectedAccountName, setSelectedAccountName] = useState('');
    const [selectedAccountNumber, setSelectedAccountNumber] = useState(''); // Guarda el numero de cuenta seleccionada.
    const [selectedAccountBank, setSelectedAccountBank] = useState('');
    const [selectedAccountCurrency, setSelectedAccountCurrency] = useState('');
    const [selectedProject, setSelectedProject] = useState(''); // Guarda el ID del proyecto seleccionado.
    const [selectedProjectName, setSelectedProjectName] = useState('');
    const [selectedCompany, setSelectedCompany] = useState(''); // Guarda la empresa relacionada con el proyecto seleccionado.


    const [numCheckVal, setNumCheckVal] = useState('');
    const [dateCheckVal, setDateCheckVal] = useState(Timestamp.fromDate(new Date()));
    const [montoVal, setMontoVal] = useState('');
    const montoRef = useRef(null);

    const [selectedProvider, setSelectedProvider] = useState('');
    const [selectedProviderName, setSelectedProviderName] = useState('');


    const [descripcion, setDescripcion] = useState('');
    const [currentDate, setCurrentDate] = useState(new Date()); //fecha en la que se esta creando el voucher

    //USEFFECT PARA CARGAR VALORES DESDE REQUISICION SELECCIONADA
    useEffect(() => {
        // ejecuta la lógica solo cuando la carga haya finalizado
        if (!loading && requiSel !== null && proveedores.length > 0 && proyectos.length > 0) {
            // Buscar el proveedor en la lista basado en requiSel
            const proveedorEncontrado = proveedores.find(prov => prov.name === requiSel.proveedor.nombre);
            if (proveedorEncontrado) {
                setSelectedProvider(proveedorEncontrado.id);
                setSelectedProviderName(proveedorEncontrado.name);
            }

            const project = proyectos.find(p => p.id === requiSel.proyecto.id);

            if (project) {
                setSelectedProject(project.id);
                setSelectedProjectName(project.project_name);
                setSelectedCompany(project.project_company);
            }

            setDescripcion(requiSel.descripcion)
            montoRef.current.value = requiSel.total
            setMontoVal(requiSel.total)
            formatInputValue()
        }
    }, [loading, requiSel, proveedores, proyectos]);



    const InputChangeNumcheck = (event) => {
        event.preventDefault();

        const { name, value } = event.target;

        if (name === 'monto') {
            // Eliminar caracteres no deseados excepto números y punto decimal
            let cleanedValue = value.replace(/[^0-9.]/g, '');

            // Limitar a dos decimales pero permitir escribir el punto
            const parts = cleanedValue.split('.');
            if (parts.length > 2) {
                cleanedValue = parts[0] + '.' + parts[1];
            }
            if (parts.length === 2 && parts[1].length > 2) {
                cleanedValue = parts[0] + '.' + parts[1].substr(0, 2);
                props.ShowWar('Esta campo solo admite números con hasta dos decimales.');
            }


            const regex = /^\d*\.?\d{0,2}$/;

            if (regex.test(cleanedValue)) {
                setMontoVal(cleanedValue);
                formatInputValue();
            } else {
                props.ShowWar('No se pueden ingresar más de dos decimales');
            }
        }

        switch (name) {
            case 'descripcion':
                setDescripcion(value);
                break;

            case 'Numcheck':
                if (/^\d*$/.test(value)) {
                    setNumCheckVal(value);
                } else {
                    props.ShowWar('Esta campo solo admite números')
                }
                break;

            case 'fecha':
                const dateParts = value.split('-').map(part => parseInt(part, 10));
                const dateObject = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
                const timestamp = Timestamp.fromDate(dateObject);
                setDateCheckVal(timestamp);
                break;

            case 'monto':


                break;

            default:
                // Manejo para otros casos o si no coincide ninguno
                break;
        }

        if (event.target.id === 'Numcheck') {
            setNumCheckTouched(true);
        } else if (event.target.id === 'fecha') {
            setDateCheckTouched(true);
        } else if (event.target.id === 'descripcion') {
            setDescripcionTouched(true);
        } else if (event.target.id === 'monto') {
            setMontoTouched(true);
        }

    }

    function formatDate(timestamp) {
        // Convertir el Timestamp de Firebase a un objeto Date
        const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);

        // Formateo de la fecha
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        month = month < 10 ? `0${month}` : month;
        day = day < 10 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    }

    //funcion para controlar el cambio en el drop down de Cuenta
    const handleAccountChange = (accountID) => {

        const account = accounts.find(p => p.id === accountID);

        if (account) {
            setSelectedAccount(account.id);
            setSelectedAccountName(account.name);
            setSelectedAccountNumber(account.account_number);
            setSelectedAccountBank(account.bank);
            setSelectedAccountCurrency(account.currency);
        } else {
            setSelectedAccount(null);
            setSelectedAccountName('');
            setSelectedAccountNumber('');
            setSelectedAccountBank('');
            setSelectedAccountCurrency('');
        }
        setButtonClicked(true);
        setAccountOpen(false);

    };


    //Para imprimir
    const pdfRef = useRef(null);

    const mostrarVistaPreviaImpresion = () => {

        const pdfStyles = getPDFStyles();
        if (pdfRef.current) {
            const contenido = pdfRef.current.innerHTML;
            const printWindow = window.open('', '_blank');
            if (printWindow) {  // Verificar que la ventana se haya abierto

                printWindow.document.write('<html><head><title>VOUCHER</title>');
                // Inyecta los estilos CSS
                printWindow.document.write(`<style>${pdfStyles}</style>`);
                printWindow.document.write('</head><body>');
                printWindow.document.write(contenido);
                printWindow.document.write('</body></html>');
                printWindow.document.close();

                // Evento que detecta el cierre de la ventana de impresión
                const checkWindowClosed = setInterval(() => {
                    if (printWindow.closed) {
                        window.focus();  // Devuelve el foco a la ventana principal
                        clearInterval(checkWindowClosed);  // Detiene la verificación
                        printWindow.close();
                    }
                }, 100);

                printWindow.addEventListener('afterprint', function () {
                    printWindow.close();
                });
                printWindow.print();
            } else {
                console.error("No se pudo abrir la ventana de impresión. Verifica los bloqueadores de ventanas emergentes.");
            }

        } else {
            console.error("Referencia no disponible");
        }
    };

    //menu desplegable de proveedores
    const handleProviderClick = (providerId) => {
        setSelectedProvider(providerId);
        setButtonClickedB(true);
        setIsOpen(false); // Cierra el menú después de seleccionar
        const provider = proveedores.find(p => p.id === providerId);
        if (provider) {
            setSelectedProviderName(provider.name);
        }
    };

    //estados para agregar nuevo proveedor
    const [isAddingProvider, setIsAddingProvider] = useState(false);
    const [newProviderName, setNewProviderName] = useState('');

    //funcion para agregar nuevo proveedor
    const handleAddNewProvider = async () => {

        if (newProviderName.trim() === '') {
            props.ShowWar("El nombre del proveedor no puede estar vacío");
            return;
        }
        try {
            const newProvider = await addNewProvider(newProviderName);
            if (newProvider.success) {
                // Actualiza el estado de los proveedores con el nuevo proveedor.
                setProveedores(prevProviders => [...prevProviders, { id: newProvider.id, name: newProvider.name }]);

                setNewProviderName('');
                setIsAddingProvider(false);
                props.ShowDone(newProvider.message)
            } else {
                props.showErr(newProvider.error)
                props.ShowWar(newProvider.message)
            }

        } catch (error) {
            console.error("Error al agregar proveedor: ", error);
            props.showErr("Error inesperado al agregar proveedor.")
        }
    }

    //funcion para controlar el cambio en el drop down de Proyecto
    const handleProjectChange = (projectId) => {

        const project = proyectos.find(p => p.id === projectId);

        if (project) {
            setSelectedProject(project.id);
            setSelectedProjectName(project.project_name);
            setSelectedCompany(project.project_company);
        } else {
            setSelectedProject(null);
            setSelectedProjectName("");
            setSelectedCompany('');
        }
        setProjectOpen(false);
    };

    //cerrar el menu al darle click fuera
    useEffect(() => {
        function handleDocumentClick(event) {

            // Verificar si el clic es fuera del menú "card-informacion-solicitud-cheque"
            if (isOpen && !event.target.closest('.card-informacion-solicitud-voucher')) {
                setIsOpen(false);
            }

            // Verificar si el clic es fuera del menú "field-container-proyecto"
            if (isAccountOpen && !event.target.closest('.field-container-proyecto')) {
                setAccountOpen(false);
            }

            // Verificar si el clic es fuera del menú "field-container-proyecto"
            if (isProjectOpen && !event.target.closest('.field-container-proyecto')) {
                setProjectOpen(false);
            }
        }

        document.addEventListener('mousedown', handleDocumentClick);

        return () => {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
    }, [isOpen, isAccountOpen, isProjectOpen]);


    // useEffect para verificar que los datos necesarios contengan informacion
    useEffect(() => {
        // Comprobar si todos los campos tienen datos
        const allFieldsFilled = selectedAccount &&
            selectedAccountName &&
            selectedAccountNumber &&
            selectedProvider &&
            selectedProviderName &&
            descripcion &&
            dateCheckVal &&
            numCheckVal &&
            montoVal;

        // Habilitar o deshabilitar el botón basado en si todos los campos están llenos
        setUpdate(allFieldsFilled);
    }, [selectedAccount, selectedAccountName, selectedAccountNumber, selectedProvider, descripcion, dateCheckVal, numCheckVal, montoVal]);


    //enviar Voucher a almacenar
    const handleSaveChanges = async () => {

        setIsLoading(true);
        try {

            //Creando la estructura del voucher
            const newVoucherData = {
                account: {
                    id: selectedAccount,
                    bank: selectedAccountBank,
                    currency: selectedAccountCurrency,
                    account_number: selectedAccountNumber,
                    name: selectedAccountName
                },
                check: {
                    number: numCheckVal,
                    date: dateCheckVal,
                    beneficiary_id: selectedProvider,
                    beneficiary: selectedProviderName,
                    descripcion: descripcion,
                    amount: Number(montoVal)
                },
                correlativo: correlativo,
                user_creator: useUser.nombre,
                date_creation: currentDate,
                estado: 'Pendiente',
                voucher_requisition: false,
            };

            // Agregar propiedad si viene de proyecto
            if (requiSel) {
                newVoucherData.voucher_requisition = true;
                newVoucherData.project = {
                    id_requi: requiSel.id,
                    requisition: requiSel.correlativo,
                    id_project: selectedProject,
                    compania: selectedCompany,
                    nombre: selectedProjectName
                };
            }

            const result = await addVoucher(newVoucherData);

            if (result.success) {
                //Limpiar todos los datos
                setSelectedAccount('')
                setSelectedAccountBank('')
                setSelectedAccountCurrency('')
                setSelectedAccountNumber('')
                setSelectedAccountName('')

                setSelectedProject(null);
                setSelectedProjectName("");
                setSelectedCompany('');

                setNumCheckVal('')
                setDateCheckVal(Timestamp.fromDate(new Date()))
                setSelectedProvider('')
                setSelectedProviderName('')
                setDescripcion('')
                setMontoVal('')

                setButtonClicked(false);
                setButtonClickedB(false);
                setNumCheckTouched(false);
                setDateCheckTouched(false);
                setDescripcionTouched(false);
                setMontoTouched(false);

                if (montoRef.current) {
                    montoRef.current.value = '';
                }

                setCorrelativo(await getNextVoucherNumber())
                setCurrentDate(new Date())

                setUpdate(false);
                setIsLoading(false);

                props.ShowDone(result.message)

                if (requiSel) {
                    navigate('/requisicion/historial');
                } else {
                    navigate('/voucher/nuevo')
                }

            } else {
                props.showErr(result.error)
                props.ShowWar(result.message)
                setIsLoading(false);
            }

        } catch (error) {
            props.showErr("No es posible crear el voucher.");
            props.ShowWar(error)
            setIsLoading(false);
        }
    };


    function formatCurrencyLive(value) {

        //solo quitar las comas del value
        value = value.replace(/,/g, '');

        // Verificar si el valor contiene caracteres no permitidos
        const regex = /[^0-9.]/g;
        if (regex.test(value)) {
            props.ShowWar('Esta campo solo admite números con hasta dos decimales');
        }

        // Eliminar caracteres no deseados excepto números y punto decimal
        value = value.replace(/[^0-9.]/g, '');

        // Separar la parte entera y decimal
        let [integerPart, decimalPart] = value.split('.');

        // Limitar la parte decimal a dos dígitos
        if (decimalPart) {
            decimalPart = decimalPart.substring(0, 2);
        }

        // Formatear la parte entera y reconstruir el valor
        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
    }


    const formatInputValue = () => {
        if (!montoRef.current) return;

        const input = montoRef.current;
        let cursorPosition = input.selectionStart;
        const originalLength = input.value.length;

        input.value = formatCurrencyLive(input.value);

        const newLength = input.value.length;
        cursorPosition = cursorPosition + (newLength - originalLength);

        // Ajustar la posición del cursor en caso de eliminación o adición de comas
        if (input.value[cursorPosition - 1] === ',') {
            cursorPosition--; // Mover el cursor antes de la coma
        }

        input.setSelectionRange(cursorPosition, cursorPosition);
    };

    //Para saber donde retroceder
    const gotoBack = () => {
        if (requiSel) {
            navigate('/requisicion/historial');
        } else {
            navigate("/voucher/historial")
        }
    };


    return (
        <>
            {!loading && (
                <div>
                    < HeaderHome
                        userLoged={useUser}
                    />
                    <div className='bodyHome-user' >

                        < Menu
                            userLoged={useUser}
                        />

                        <div style={{ width: "100%" }}>
                            <a className="back-button-requis" onClick={() => gotoBack()}> <IoIosArrowBack style={{ marginRight: "10px" }} /> Regresar</a>
                            <div className="titulo-container-solicitud">
                                <p style={{ fontWeight: "500" }}>Nuevo Voucher</p>
                                <div ref={pdfRef} hidden={true}>
                                    <PDFComponent
                                        fecha={dateCheckVal.toDate().toLocaleString('es-GT', {
                                            year: 'numeric',
                                            month: '2-digit',
                                            day: '2-digit'
                                        }).replace(/(\d+)\/(\d+)\/(\d+)/i, '$1/$2/$3')}
                                        numero={correlativo}
                                        cuenta_num={selectedAccountNumber}
                                        cuenta_name={selectedAccountName}
                                        check={numCheckVal}
                                        proveedor={selectedProviderName}
                                        descripcion={descripcion}
                                        total={montoVal}
                                        proyecto={requiSel ? selectedProjectName : null}
                                        items={requiSel ? requiSel.details : null}
                                    />

                                </div>
                                <button onClick={mostrarVistaPreviaImpresion}><FiPrinter style={{ marginRight: "10px" }} /> Imprimir</button>
                            </div>
                            <div className='header-solicitud'>
                                {requiSel ? <span>Requisición # {requiSel.correlativo}</span> : ""}
                                <span>Voucher #  {correlativo}</span>
                            </div>
                            <div className='card-informacion-solicitud'>
                                <div className="card-informacion-solicitud-span">
                                    <span>Información Básica</span>
                                </div>
                                <div className="card-informacion-solicitud-voucher">
                                    <div className="field-container-proyecto">
                                        <label>Cuenta Bancaria</label>
                                        <button onClick={() => setAccountOpen(!isAccountOpen)} style={{ marginTop: "5px", textAlign: "left" }} className={buttonClicked ? 'button-clicked' : ''}>
                                            {accounts.find(p => p.id === selectedAccount)
                                                ? `${accounts.find(p => p.id === selectedAccount).name} - ${accounts.find(p => p.id === selectedAccount).bank}`
                                                : "Selecciona una cuenta bancaria"}
                                            {isAccountOpen ? <IoIosArrowUp style={{ fontSize: "25px" }} /> : <IoIosArrowDown style={{ fontSize: "25px" }} />}
                                        </button>

                                        {isAccountOpen && (
                                            <div className="dropdown-container-proyecto">
                                                <ul>
                                                    {accounts.map(account => (
                                                        <li key={account.id}>
                                                            <button style={{ textAlign: "left" }} onClick={() => handleAccountChange(account.id)} >
                                                                {account.name} - {account.bank} [{account.currency}]
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>

                                    <div className="field-container-proyecto">
                                        <label>No. de cuenta</label>
                                        <input className="card-informacion-solicitud-voucher-input" type="text" disabled={true} value={selectedAccountNumber} />
                                    </div>
                                </div>
                            </div>
                            <div className='card-detalle-voucher'>
                                <div className='card-detalle-voucher-span'>
                                    <span>Descripción del Cheque</span>
                                </div>
                                <div className="card-informacion-solicitud-voucher">
                                    <div className="field-container-voucher">
                                        <label>No. de Cheque</label>
                                        <input id='Numcheck' name='Numcheck' onChange={InputChangeNumcheck} placeholder="Escribe el No. del cheque" value={numCheckVal} style={{ borderColor: numCheckTouched ? '#3A93F7' : '' }} />
                                    </div>
                                    <div className="field-container-voucher">
                                        <label>Fecha</label>
                                        <input type="date" id='fecha' name='fecha' onChange={InputChangeNumcheck} value={formatDate(dateCheckVal)} style={{ borderColor: dateCheckTouched ? '#3A93F7' : '' }} />
                                    </div>
                                </div>
                                <div className="card-informacion-solicitud-voucher">
                                    <label>Beneficiario</label>
                                    <button onClick={() => setIsOpen(!isOpen)} style={{ marginTop: "5px", width: "98%", marginBottom: "13px" }} className={buttonClickedB ? 'button-clicked' : ''}>
                                        {selectedProviderName || "Escribe el nombre del beneficiario"}
                                        {isOpen ? <IoIosArrowUp style={{ fontSize: "25px" }} /> : <IoIosArrowDown style={{ fontSize: "25px" }} />}
                                    </button>
                                    {isOpen && (
                                        <div className="dropdown-cheque">
                                            <ul>
                                                {isAddingProvider ? (
                                                    <div className="dropdown-cheque-nuevo-proveedor">
                                                        <input
                                                            type="text"
                                                            value={newProviderName}
                                                            onChange={(e) => setNewProviderName(e.target.value)}
                                                            placeholder="Nombre del nuevo proveedor"
                                                        />
                                                        <button onClick={handleAddNewProvider}>Guardar</button>
                                                        <button onClick={() => setIsAddingProvider(false)} style={{ backgroundColor: "#647787" }}>Cancelar</button>
                                                    </div>
                                                ) : (
                                                    <li>
                                                        <button onClick={() => setIsAddingProvider(true)} style={{ color: "#3A93F7", paddingLeft: "10px" }}>
                                                            + Agregar nuevo proveedor
                                                        </button>
                                                    </li>
                                                )}
                                                {proveedores.map(provider => (
                                                    <li key={provider.id}>
                                                        <button style={{ paddingLeft: "10px" }} onClick={() => handleProviderClick(provider.id)}
                                                            className={selectedProvider === provider.id ? 'selected' : ''}>
                                                            {provider.name}
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>

                                    )}
                                </div>

                                {requiSel ?
                                    <div className="card-informacion-solicitud-proyecto">
                                        <div className="field-container-proyecto" style={{ width: "100%" }}>
                                            <label>Financiamiento</label>
                                            <button onClick={() => setProjectOpen(!isProjectOpen)} style={{ marginTop: "5px", width: "98%" }}>
                                                {proyectos.find(p => p.id === selectedProject)?.project_name || "Selecciona un proyecto"}
                                                {isProjectOpen ? <IoIosArrowUp style={{ fontSize: "25px" }} /> : <IoIosArrowDown style={{ fontSize: "25px" }} />}
                                            </button>

                                            {isProjectOpen && (
                                                <div className="dropdown-container-proyecto">
                                                    <ul>
                                                        {proyectos.map(project => (
                                                            <li key={project.id}>
                                                                <button onClick={() => handleProjectChange(project.id)}>
                                                                    {project.project_name} - {project.project_company}
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    :
                                    ""
                                }

                                <div className="card-informacion-solicitud-description">
                                    <label>Descripción</label>
                                    <textarea
                                        name="descripcion"
                                        id="descripcion"
                                        placeholder="Escribe la descripción del cheque"
                                        value={descripcion}
                                        onChange={InputChangeNumcheck}
                                        style={{ borderColor: descripcionTouched ? '#3A93F7' : '' }}>
                                    </textarea>
                                </div>

                                <div className="monto-voucher">
                                    <label>Monto</label>
                                    <span className="input-with-q-wrapper">
                                        <input
                                            ref={montoRef}
                                            id='monto'
                                            name='monto'
                                            className="input-with-q"
                                            onChange={InputChangeNumcheck}
                                            style={{ borderColor: montoTouched ? '#3A93F7' : '' }}
                                            placeholder="Escribe el monto del cheque"
                                        />
                                    </span>
                                </div>


                            </div>
                            <div className='button-container-solicitud'>
                                {update ? (
                                    <button className='botonPrincipal-solicitud' onClick={handleSaveChanges}>Guardar</button>
                                ) : (
                                    <button className='botonSecondary-solicitud' disabled={true}>Guardar</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {isLoading && <LoadingModal />}
        </>
    );
}

export default NuevoVoucher;